module.exports = __webpack_public_path__ + "img/shop.f7da40e7.svg";